import React from "react";
import { replaceNewLinesWithBrLimited } from "utilities/reactUtils";
import OptionalTextAreaInput, { OptionalTextAreaInputProps } from "./OptionalTextAreaInput";

const OptionalCodeAreaInput = (props: OptionalTextAreaInputProps) => {
  return <OptionalTextAreaInput
    {...props}
    style={{ fontFamily: "\"Courier New\", monospace", ...props.style }}
  />;
}

interface OptionalCodeAreaDetailsProps {
  children: string
  rows: number
}

export const OptionalCodeAreaDetails = (props: OptionalCodeAreaDetailsProps) => {
  return <div style={{
    fontFamily: "\"Courier New\", monospace"
  }}>
    {replaceNewLinesWithBrLimited(props.children, props.rows)}
  </div>
}

export default OptionalCodeAreaInput;